import { render, staticRenderFns } from "./EditMailDestination.vue?vue&type=template&id=4357116a&scoped=true"
import script from "./EditMailDestination.vue?vue&type=script&lang=js"
export * from "./EditMailDestination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4357116a",
  null
  
)

export default component.exports